import { render, staticRenderFns } from "./WelcomeMain.vue?vue&type=template&id=41e3df57&scoped=true"
import script from "./WelcomeMain.vue?vue&type=script&lang=js"
export * from "./WelcomeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e3df57",
  null
  
)

export default component.exports